export default __webpack_public_path__ + "static/media/shopnow.99f25315.png";